import Lookup from 'src/componentes/select2';

const PeriodicidadeRecorrenciaOneAOneLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/PeriodicidadeRecorrenciaLookup"
    {...rest}
  />
);

export default PeriodicidadeRecorrenciaOneAOneLookup;
